import React from 'react'
import { Tooltip } from '@tecsinapse/cortex-react'
import { FaRegCopy } from 'react-icons/fa'
import { copyToClipboardVariants } from '@web/modules/core/styles/copyToClipboardVariants'

interface CopyToClipboardProps {
  copyData: string
  enable: boolean
  onMouseOver: () => void
  onMouseLeave: () => void
  handleCopy: (data: string) => void
  size?: 'small' | 'medium' | 'large'
}

const { container, icon } = copyToClipboardVariants()

const CopyToClipboard = ({ copyData, handleCopy, enable, onMouseOver, onMouseLeave, size }: CopyToClipboardProps) => {
  return (
    <div className={container()}>
      {enable ? (
        <Tooltip
          text='Copiado'
          trigger='click'
          placement='bottom'
        >
          <FaRegCopy
            className={icon({ size })}
            onClick={() => handleCopy(copyData)}
            onMouseOver={onMouseOver}
            onMouseLeave={onMouseLeave}
          />
        </Tooltip>
      ) : (
        <></>
      )}
    </div>
  )
}

export default CopyToClipboard
